<template>
  <div class="index-container">
    <!-- banner图 -->
    <div class="banner">
      <el-carousel
        :interval="5000"
        indicator-position="none"
        arrow="always"
        height="400px"
      >
        <el-carousel-item v-for="(item, i) in slideData" :key="i">
          <img :src="item.image" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 热门服务分类 -->
    <div class="services-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t("hotServiceCategory") }}</h2>
        <div class="scroll-indicator">
          <span>{{ $t("swipeToSeeMore") }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <div class="service-scroll-container" ref="gridContainer">
        <div class="service-grid">
          <el-card
            class="service-card"
            :body-style="{ padding: '16px' }"
            v-for="(item, index) in hotServiceList"
            :key="index"
          >
            <img :src="item.image" class="service-img" alt="service" />
            <h3 class="service-title">
              {{ $i18n.locale === "zh" ? item.name : item.name_en }}
            </h3>
            <p class="service-desc">
              {{ $i18n.locale === "zh" ? item.describe : item.describe_en }}
            </p>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 推荐服务分类 -->
    <div class="recommended-services" v-if="recommendServiceList.length > 0">
      <div class="title-bar">
        <h2 class="recommend-title">{{ $t("recommendedServices") }}</h2>
        <div
          class="scroll-indicator"
          @click="goToListPage('/travel/route-list')"
        >
          <span>{{ $t("viewMore") }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-row :gutter="24">
        <el-col
          :xs="24"
          :sm="12"
          :md="6"
          v-for="(item, index) in recommendServiceList"
          :key="index"
        >
          <el-card
            class="recommend-card"
            @click.native="handleButtonClick(item.id)"
          >
            <img :src="item.cover_image" class="service-img" alt="service" />
            <div class="service-info">
              <span class="tag" :style="{ backgroundColor: item.tagBgColor }">{{
                item.tag
              }}</span>
              <span class="price">{{ item.price }}</span>
              <h3 class="service-title">{{ item.route_name }}</h3>
              <p class="desc">{{ item.intro }}</p>
              <div class="bottom-info">
                <span class="rating"
                  >{{ item.rating }} ({{ item.evaluationCount }}
                  {{ $t("evaluation") }})</span
                >
                <el-button type="primary" class="book-btn">{{
                  $t("bookNow")
                }}</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 推荐房源服务 -->
    <div class="recommended-services">
      <div class="title-bar">
        <h2 class="recommend-title">{{ $t("recommendedHouses") }}</h2>
        <div
          class="scroll-indicator"
          @click="
            goToListPage(
              'https://www.rent.move2china.com/index/index/houselist',
            )
          "
        >
          <span>{{ $t("viewMore") }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-row :gutter="24">
        <el-col
          :xs="24"
          :sm="12"
          :md="6"
          v-for="(item, index) in recommendHouseList"
          :key="index"
        >
          <el-card
            class="recommend-card-house"
            @click.native="
              goToListPage(
                'https://www.rent.move2china.com/index/detail/index?id=' +
                  item.id,
              )
            "
          >
            <img :src="item.image" class="service-img" alt="service" />
            <div class="service-info">
              <h3 class="service-title">{{ item.fytitle }}</h3>
              <p class="house-info">
                {{ $t("houseType") }}： {{ item.rooms }}{{ $t("room")
                }}{{ item.lobby }}{{ $t("hall") }}{{ item.toilet
                }}{{ $t("bathroom") }}
              </p>
              <div class="info">
                <p class="house-info">{{ $t("area") }}：{{ item.district }}</p>
                <span class="house-price"
                  ><span class="icon-yuan">¥</span>{{ item.price }}</span
                >
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 值得信赖服务平台 -->
    <div class="trust-platform-stats">
      <div class="stats-header">
        <h2 class="stats-title">{{ $t("trustedPlatform") }}</h2>
        <p class="stats-desc">{{ $t("trustedPlatformDesc") }}</p>
      </div>
      <el-row :gutter="20" class="stats-items">
        <el-col
          :xs="24"
          :sm="12"
          :md="6"
          v-for="(item, index) in statsList"
          :key="index"
        >
          <div class="stats-item">
            <p class="stats-number">
              {{ item.value }}
            </p>
            <p class="stats-label">
              {{ $i18n.locale === "zh" ? item.desc : item.desc_en }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      slideData: [],
      configData: null,
      hotServiceList: [],
      recommendServiceList: [],
      statsList: [],
      recommendHouseList: [],
    };
  },
  computed: {
    showScrollIndicator() {
      return (
        this.$refs.gridContainer &&
        this.$refs.gridContainer.scrollWidth >
          this.$refs.gridContainer.clientWidth
      );
    },
  },
  watch: {
    "$i18n.locale"() {
      // 新增：刷新首页推荐服务
      this.getRecommendRoute();
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkScrollIndicator);
    this.checkScrollIndicator();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScrollIndicator);
  },
  created() {
    this.getBanner();
    this.fetchConfigData()
      .then((res) => {
        this.statsList = res.service;
      })
      .catch((error) => {
        console.error("配置数据加载失败:", error);
      });
    this.getHotServiceCategory();
    this.getRecommendRoute();
    this.getRecommendHouse();
  },
  methods: {
    ...mapActions("config", ["fetchConfigData"]),
    getBanner() {
      this.$get("/get_banner").then((res) => {
        this.slideData = res.data.data;
      });
    },
    checkScrollIndicator() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    getHotServiceCategory() {
      this.$get("/hot_category").then((res) => {
        if (res.data.code === 1) {
          this.hotServiceList = res.data.data;
        } else {
          console.error("获取热门分类失败：", res.msg);
        }
      });
    },
    getRecommendRoute() {
      const lang = this.$i18n.locale || "zh";
      this.$get("/recommend_service", {
        language: lang,
      }).then((res) => {
        if (res.data.code === 1) {
          this.recommendServiceList = res.data.data;
        } else {
          console.error("获取推荐服务失败：", res.msg);
        }
      });
    },
    getRecommendHouse() {
      this.$get("/recommend_house").then((res) => {
        if (res.data.code === 1) {
          this.recommendHouseList = res.data.data;
        } else {
          console.error("获取推荐房源服务失败：", res.msg);
        }
      });
    },
    goToListPage(path) {
      if (path && path.startsWith("http")) {
        window.open(path, "_blank");
        return;
      } else {
        this.$router.push(path);
      }
    },
    handleButtonClick(routeId) {
      this.$router.push({
        path: "/travel/route-detail",
        query: { id: routeId },
      });
    },
  },
};
</script>

<style scoped>
.index-container {
  background: #f9fafb;
}

.services-section,
.recommended-services {
  padding: 20px 80px;
  overflow-x: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title,
.recommend-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.scroll-indicator {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
  font-size: 0.9rem;
  animation: bounce 2s infinite;
}

.service-scroll-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #c0c4cc transparent;
  min-width: 100%;
}

.service-scroll-container::-webkit-scrollbar {
  height: 6px;
}

.service-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.service-scroll-container::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
  border-radius: 3px;
}

.service-grid {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 340px;
  gap: 4px;
  padding-bottom: 10px;
  width: max-content;
}

.service-card {
  width: 320px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.recommend-card,
.recommend-card-house {
  margin-bottom: 10px;
  overflow: hidden;
  cursor: pointer;
}

.recommend-card {
  height: 380px;
}

.recommend-card-house {
  height: 350px;
}

.service-card,
.recommend-card {
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.service-card:hover,
.recommend-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.service-card:hover .service-img,
.recommend-card:hover .service-img,
.recommend-card-house:hover .service-img {
  transform: scale(1.05);
}

.service-img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 12px;
  transition: transform 0.3s ease;
}

.service-title {
  height: 42px;
  font-size: 1.125rem;
  margin-bottom: 8px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.service-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
  margin-bottom: 16px;
  flex-grow: 1;
}

.mt-auto {
  margin-top: auto;
}

.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.service-card {
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.service-img {
  width: 100%;
  border-radius: 4px 4px 0 0;
}

.tag {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  color: #666;
  font-size: 12px;
  margin-right: 8px;
}

.price {
  color: #ff9900;
  font-size: 14px;
}

.house-price {
  color: #ff9900;
  font-size: 24px;
  font-weight: bold;
}
.house-price .icon-yuan {
  font-size: 14px;
}

.service-title {
  font-size: 16px;
  font-weight: bold;
  margin: 8px 0;
}

.desc {
  height: 40px;
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  max-height: 45px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.house-info {
  font-size: 14px;
}

.bottom-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rating {
  font-size: 13px;
  color: #999;
}

.consult-btn,
.book-btn,
.reserve-btn {
  padding: 6px 12px;
  font-size: 13px;
}

.trust-platform-stats {
  border-radius: 4px;
  padding: 20px;
  background: #ffffff;
}

.stats-header {
  text-align: center;
  margin-bottom: 20px;
}

.stats-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.stats-desc {
  font-size: 14px;
  color: #666;
}

.stats-items {
  text-align: center;
}

.stats-item {
  padding: 15px;
}

.stats-number {
  font-size: 24px;
  color: #409eff;
  font-weight: bold;
  margin-bottom: 5px;
}
.stats-label {
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  ::v-deep .el-carousel__container {
    height: 200px !important;
  }
  .services-section,
  .recommended-services {
    padding: 20px 10px;
  }
  .el-col {
    width: 100%;
  }
  .stats-title {
    font-size: 18px;
  }
  .stats-number,
  .stats-label {
    margin: 5px 0px;
  }
  .stats-number {
    font-size: 20px;
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(3px);
  }
}
.el-carousel__container .el-carousel__item img {
  width: 100%;
  height: -webkit-fill-available;
}
</style>
<style>
.el-card__body {
  padding: 16px;
}
</style>
